module.exports = __webpack_public_path__ + "img/1566580726.ce68dfc7.jpg";